import { Typography } from "antd";
import styled from "styled-components";

const Title = styled(Typography.Title)`
  padding: 0 0 10px;
`;

export default Title;
